
export default (state = {}, action) => {
  switch (action.type) {
    case 'DEAL_ALERT_FETCH_BEGINS':
      return {
        loader: true,
        error: false,
        result: null
      }

    case 'DEAL_ALERT_FETCH_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload.message
      }

    case 'DEAL_ALERT_FETCH_FAILURE':
      return {
        loader: false,
        error: true,
        result: null
      }
    default:
      return state
  }
}